import React, { useEffect, useState } from 'react';
import SiteShell, { Reveal } from './SiteShell';
import api from '../api/client';

// Default policy used until the admin writes their own in Settings.
const defaultPolicy = (name, email, phone) => `
${name} ("we", "us") operates the Narayan mobile application and this website. This policy explains what we collect, why, and the choices you have.

INFORMATION WE COLLECT
• Account details — your name, mobile number and email address when you register.
• Address — the service address you provide so we can send a professional to you.
• Identity documents (service professionals only) — Aadhaar and PAN details and a selfie, used solely to verify identity (KYC) before a professional is allowed to take jobs.
• Booking & payment records — services you book, amounts paid and payment reference IDs. Card/UPI details are handled by our payment gateway (Razorpay); we never store them.
• Device & usage data — basic app/website usage needed to keep the service reliable and secure.

HOW WE USE IT
• To create and manage your account and bookings.
• To verify service professionals so customers stay safe.
• To process payments, refunds and payouts.
• To send booking updates and support messages (including WhatsApp/SMS notifications).
• To improve our services and meet legal obligations.

SHARING
We do not sell your personal data. We share only what is necessary with:
• The assigned professional (your name, service address and booking details).
• Payment and verification providers who process transactions/KYC on our behalf.
• Authorities, where required by law.

DATA RETENTION
We keep your data while your account is active and for as long as required by tax and legal obligations. You may ask us to delete it at any time (see "Your rights").

SECURITY
Documents and images are stored on access-controlled cloud storage and served through short-lived, signed links. Sensitive credentials are never exposed to the app.

YOUR RIGHTS
You can access, correct or delete your data. To delete your account and associated data, use the "Delete Account" page on this website or contact us. We will action verified requests within 30 days, except records we must retain by law.

CHILDREN
Our services are not directed to anyone under 18.

CHANGES
We may update this policy; the "last updated" date below always reflects the current version.

CONTACT
${email ? `Email: ${email}` : ''}${email && phone ? '\n' : ''}${phone ? `Phone: ${phone}` : ''}
`.trim();

export default function Privacy() {
  const [s, setS] = useState({});
  useEffect(() => { api.get('/settings/public').then((d) => setS(d || {})).catch(() => {}); }, []);

  const name = s.companyName || 'Narayan Home Facility Services';
  const body = s.privacyPolicy && s.privacyPolicy.trim()
    ? s.privacyPolicy
    : defaultPolicy(name, s.supportEmail, s.companyPhone);

  return (
    <SiteShell settings={s}>
      <div className="wrap doc">
        <Reveal>
          <h1>Privacy Policy</h1>
          <p className="upd">
            Last updated: {new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })}
          </p>
          <p className="pre">{body}</p>
        </Reveal>
      </div>
    </SiteShell>
  );
}
